import PreviewSection from '../../PreviewSection'

export default function ProfitLossHTMLPreviewBaseSection () {}

ProfitLossHTMLPreviewBaseSection.prototype = new PreviewSection();

ProfitLossHTMLPreviewBaseSection.prototype.init = function ( columnsStrategy )
{
    this.columnsStrategy = columnsStrategy;
    return this;
};

ProfitLossHTMLPreviewBaseSection.prototype.addRowWithMainCell = function( tBody, mainCellText, mainCellClass, rowClass )
{
    var row = this.createRow( rowClass );
    this.addCell( row, mainCellText, mainCellClass );
    this.columnsStrategy.addDataCells( row );
    this.addRow( tBody, row );
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/profitloss/ProfitLossHTMLPreviewBaseSection.js